import { History } from "history";

import {
  ADD_SKILL,
  ADD_SKILL_ERROR,
  ADD_SKILL_SUCCESS,
  AddSkillAction,
  AddSkillErrorAction,
  AddSkillSuccessAction,
  COPY_SKILLS,
  COPY_SKILLS_ERROR,
  COPY_SKILLS_SUCCESS,
  CopySkillsAction,
  CopySkillsErrorAction,
  CopySkillsResetAction,
  CopySkillsSuccessAction,
  DELETE_SKILL,
  DELETE_SKILL_CONSENT,
  DELETE_SKILL_ERROR,
  DELETE_SKILL_SUCCESS,
  DeleteSkillAction,
  DeleteSkillConsentAction,
  DeleteSkillErrorAction,
  DeleteSkillSuccessAction,
  GET_SKILL,
  GET_SKILLS,
  GET_SKILLS_BY_LESSON,
  GET_SKILLS_BY_LESSON_ERROR,
  GET_SKILLS_BY_LESSON_SUCCESS,
  GET_SKILLS_BY_SUBJECT,
  GET_SKILLS_BY_SUBJECT_ERROR,
  GET_SKILLS_BY_SUBJECT_SUCCESS,
  GET_SKILLS_ERROR,
  GET_SKILLS_SUCCESS,
  GET_SKILLS_SUGGESTION,
  GET_SKILLS_SUGGESTION_ERROR,
  GET_SKILLS_SUGGESTION_SUCCESS,
  GET_SKILL_ERROR,
  GET_SKILL_SUCCESS,
  GetSkillAction,
  GetSkillErrorAction,
  GetSkillSuccessAction,
  GetSkillsAction,
  GetSkillsByLessonAction,
  GetSkillsByLessonErrorAction,
  GetSkillsByLessonSuccessAction,
  GetSkillsBySubjectAction,
  GetSkillsBySubjectErrorAction,
  GetSkillsBySubjectSuccessAction,
  GetSkillsErrorAction,
  GetSkillsSuccessAction,
  GetSkillsSuggestionAction,
  GetSkillsSuggestionErrorAction,
  GetSkillsSuggestionSuccessAction,
  RESET_COPY_CUT_SKILLS,
  TOGGLE_ADD_EDIT_SKILL_MODAL,
  TOGGLE_SKILL_STATE,
  TOGGLE_SKILL_STATE_CONSENT,
  TOGGLE_SKILL_STATE_ERROR,
  TOGGLE_SKILL_STATE_SUCCESS,
  ToggleAddEditSkillModalAction,
  ToggleSkillStateAction,
  ToggleSkillStateConsentAction,
  ToggleSkillStateErrorAction,
  ToggleSkillStateSuccessAction,
  UPDATE_SKILL,
  UPDATE_SKILL_ERROR,
  UPDATE_SKILL_SUCCESS,
  UPLOAD_SKILL_VIDEO,
  UPLOAD_SKILL_VIDEO_ERROR,
  UPLOAD_SKILL_VIDEO_PROGRESS,
  UPLOAD_SKILL_VIDEO_SUCCESS,
  UpdateSkillAction,
  UpdateSkillErrorAction,
  UpdateSkillSuccessAction,
  UploadSkillVideoAction,
  UploadSkillVideoErrorAction,
  UploadSkillVideoProgressAction,
  UploadSkillVideoSuccessAction,
} from "./actionTypes";
import {
  CreateSkillRequest,
  SkillDto,
  PaginateQuery,
  UpdateSkillRequest,
  SkillsSuggestionRequest,
  CopyCutSkillRequest,
} from "../../interfaces";
import { Paginated } from "../../models";
import { MediaDto } from "../../interfaces/media";

//#region Get Skills

export const getSkills = (
  request: PaginateQuery,
  history: History
): GetSkillsAction => {
  return {
    type: GET_SKILLS,
    payload: { request, history },
  };
};

export const getSkillsSuccess = (
  response: Paginated<SkillDto>
): GetSkillsSuccessAction => {
  return {
    type: GET_SKILLS_SUCCESS,
    payload: response,
  };
};

export const getSkillsError = (error: any): GetSkillsErrorAction => {
  return {
    type: GET_SKILLS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Skills by Lesson Id

export const getSkillsByLesson = (
  lessonId: string,
  history: History
): GetSkillsByLessonAction => {
  return {
    type: GET_SKILLS_BY_LESSON,
    payload: { lessonId, history },
  };
};

export const getSkillsByLessonSuccess = (
  response: SkillDto[]
): GetSkillsByLessonSuccessAction => {
  return {
    type: GET_SKILLS_BY_LESSON_SUCCESS,
    payload: response,
  };
};

export const getSkillsByLessonError = (
  error: any
): GetSkillsByLessonErrorAction => {
  return {
    type: GET_SKILLS_BY_LESSON_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Skills by Subject Id

export const getSkillsBySubject = (
  subjectId: string,
  history: History
): GetSkillsBySubjectAction => {
  return {
    type: GET_SKILLS_BY_SUBJECT,
    payload: { subjectId, history },
  };
};

export const getSkillsBySubjectSuccess = (
  response: SkillDto[]
): GetSkillsBySubjectSuccessAction => {
  return {
    type: GET_SKILLS_BY_SUBJECT_SUCCESS,
    payload: response,
  };
};

export const getSkillsBySubjectError = (
  error: any
): GetSkillsBySubjectErrorAction => {
  return {
    type: GET_SKILLS_BY_SUBJECT_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Skill

export const getSkill = (id: string, history: History): GetSkillAction => {
  return {
    type: GET_SKILL,
    payload: { id, history },
  };
};

export const getSkillSuccess = (response: SkillDto): GetSkillSuccessAction => {
  return {
    type: GET_SKILL_SUCCESS,
    payload: response,
  };
};

export const getSkillError = (error: any): GetSkillErrorAction => {
  return {
    type: GET_SKILL_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Skill

export const addSkill = (
  request: CreateSkillRequest,
  history: History
): AddSkillAction => {
  return {
    type: ADD_SKILL,
    payload: { request, history },
  };
};

export const addSkillSuccess = (skill: SkillDto): AddSkillSuccessAction => {
  return {
    type: ADD_SKILL_SUCCESS,
    payload: skill,
  };
};

export const addSkillError = (error: any): AddSkillErrorAction => {
  return {
    type: ADD_SKILL_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Skill

export const updateSkill = (
  id: string,
  request: UpdateSkillRequest,
  history: History
): UpdateSkillAction => {
  return {
    type: UPDATE_SKILL,
    payload: { id, request, history },
  };
};

export const updateSkillSuccess = (
  skill: SkillDto
): UpdateSkillSuccessAction => {
  return {
    type: UPDATE_SKILL_SUCCESS,
    payload: skill,
  };
};

export const updateSkillError = (error: any): UpdateSkillErrorAction => {
  return {
    type: UPDATE_SKILL_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Skill

export const deleteSkillConsent = (id: string): DeleteSkillConsentAction => {
  return {
    type: DELETE_SKILL_CONSENT,
    payload: id,
  };
};

export const deleteSkill = (
  id: string,
  history: History
): DeleteSkillAction => {
  return {
    type: DELETE_SKILL,
    payload: { id, history },
  };
};

export const deleteSkillSuccess = (id: string): DeleteSkillSuccessAction => {
  return {
    type: DELETE_SKILL_SUCCESS,
    payload: id,
  };
};

export const deleteSkillError = (error: any): DeleteSkillErrorAction => {
  return {
    type: DELETE_SKILL_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Skill Video

export const uploadSkillVideo = (
  file: File,
  history: History,
  skillId?: string
): UploadSkillVideoAction => {
  return {
    type: UPLOAD_SKILL_VIDEO,
    payload: { file, history, skillId },
  };
};

export const uploadSkillVideoSuccess = (
  media: MediaDto
): UploadSkillVideoSuccessAction => {
  return {
    type: UPLOAD_SKILL_VIDEO_SUCCESS,
    payload: media,
  };
};

export const uploadSkillVideoError = (
  error: any
): UploadSkillVideoErrorAction => {
  return {
    type: UPLOAD_SKILL_VIDEO_ERROR,
    payload: error,
  };
};

export const uploadSkillVideoProgress = (
  progress: number
): UploadSkillVideoProgressAction => {
  return {
    type: UPLOAD_SKILL_VIDEO_PROGRESS,
    payload: progress,
  };
};

//#endregion

//#region add edit skill modal
export const toggleAddEditSkillModal = (): ToggleAddEditSkillModalAction => {
  return {
    type: TOGGLE_ADD_EDIT_SKILL_MODAL,
    payload: null,
  };
};
//#endregion

//#region Upload Skill Video

export const getSkillsSuggestion = (
  request: SkillsSuggestionRequest
): GetSkillsSuggestionAction => {
  return {
    type: GET_SKILLS_SUGGESTION,
    payload: { request },
  };
};

export const getSkillsSuggestionSuccess = (
  skills: SkillDto[]
): GetSkillsSuggestionSuccessAction => {
  return {
    type: GET_SKILLS_SUGGESTION_SUCCESS,
    payload: skills,
  };
};

export const getSkillsSuggestionsError = (
  error: any
): GetSkillsSuggestionErrorAction => {
  return {
    type: GET_SKILLS_SUGGESTION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Toggle Skill State

export const toggleSkillStateConsent = (
  id: string
): ToggleSkillStateConsentAction => {
  return {
    type: TOGGLE_SKILL_STATE_CONSENT,
    payload: id,
  };
};

export const toggleSkillState = (
  id: string,
  history: History
): ToggleSkillStateAction => {
  return {
    type: TOGGLE_SKILL_STATE,
    payload: { id, history },
  };
};

export const toggleSkillStateSuccess = (
  id: string
): ToggleSkillStateSuccessAction => {
  return {
    type: TOGGLE_SKILL_STATE_SUCCESS,
    payload: { id },
  };
};

export const toggleSkillStateError = (
  error: any
): ToggleSkillStateErrorAction => {
  return {
    type: TOGGLE_SKILL_STATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Toggle Skill State

export const copySkills = (request: CopyCutSkillRequest): CopySkillsAction => {
  return {
    type: COPY_SKILLS,
    payload: { request },
  };
};

export const copySkillsSuccess = (): CopySkillsSuccessAction => {
  return {
    type: COPY_SKILLS_SUCCESS,
    payload: null,
  };
};

export const copySkillsError = (error: any): CopySkillsErrorAction => {
  return {
    type: COPY_SKILLS_ERROR,
    payload: error,
  };
};

export const resetCopyCutSkills = (): CopySkillsResetAction => {
  return {
    type: RESET_COPY_CUT_SKILLS,
    payload: null,
  };
};

//#endregion
